// @MX:NOTE: china-inapi 이관 완료 — 이 팩토리의 호출처 두 곳(ProductsList.vue,
//   CertificateDetailModal.vue)이 모두 chinaInapi 인스턴스를 주입한다. 한국 inapi 경로는 없다.
//   파라미터명 `$apiInstance` 는 레거시 명칭이 남은 것일 뿐 주입 대상과 무관하다.
//   (SPEC-CHINA-ADMIN-CERT-FOLLOWER-EP-001 M3 완료 후 2026-07-27 사실관계 정정)
export default function productListApis($apiInstance) {
    return {
        // 제품 목록 조회
        getProductsList: async (params) => {
            try {
                const response = await $apiInstance.get('/products/admin/dentium/china', { params });
                return response;
            } catch (error) {
                console.error('Error in getProductsList:', error);
                throw error;
            }
        },
        // 시리얼 번호로 추적 정보 조회 및 업데이트
        getAndUpdateTraceBySerialNo: async (serialNo) => {
            try {
                const response = await $apiInstance.get(`/products/admin/dentium/china/trace/${serialNo}`);
                return response;
            } catch (error) {
                console.error('Error in getAndUpdateTraceBySerialNo:', error);
                throw error;
            }
        },
        // 인증서 회수 API
        recoverCertificate: async (serialNo) => {
            console.log('API call: recoverCertificate with serialNo:', serialNo);
            try {
                const url = `/products/admin/dentium/china/recover-certificate/${serialNo}`;
                console.log('API URL:', url);
                
                const response = await $apiInstance.put(url);
                console.log('API response received:', response);
                return response;
            } catch (error) {
                console.error('Error in recoverCertificate API call:', error);
                console.error('Error details:', error.response || error.message);
                throw error;
            }
        }
    }
}
